<script>
import AkInputPercentage from '@components/v2/input/AkInputPercentage.vue';
import AkFormSubmitted from '@components/general/AkFormSubmitted.vue';
import AkInputMoney from '@components/v2/input/AkInputMoney.vue';
import AkInputInteger from '@components/v2/input/AkInputInteger.vue';

export default {
  components: {AkInputInteger, AkInputMoney, AkFormSubmitted, AkInputPercentage},
  props: {
    modelValue: {
      required: true,
    },
    submitted: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    currentValue: {
      get: function () {
        return this.modelValue;
      },
      set: function (val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
};
</script>

<template>
  <AkFormSubmitted
    class="grid md:grid-cols-2 grid-cols-1 md:gap-4 gap-2 mt-4"
    :submitted="submitted"
    :disabled="disabled || loading">
    <AkInputMoney v-model="currentValue.feeCancel" :label="$t('mandat_setting.feeCancel')" />
    <AkInputPercentage v-model="currentValue.feeCancelCom" :label="$t('mandat_setting.feeCancelCom')" />
    <AkInputMoney v-model="currentValue.feeServiceVgaMinimum" :label="$t('mandat_setting.feeServiceVgaMinimum')" />
    <AkInputPercentage v-model="currentValue.feeServiceVgaCom" :label="$t('mandat_setting.feeServiceVgaCom')" />
    <AkInputInteger
      v-model="currentValue.operatingCostsMinNights"
      :label="$t('mandat_setting.operatingCostsMinNights')" />
    <AkInputMoney v-model="currentValue.operatingCosts" :label="$t('mandat_setting.operatingCosts')" />
    <div />
  </AkFormSubmitted>
</template>
